export const SET_MEETING_TIME = 'SET_MEETING_TIME'
export const TOGGLE_MEETING_MODAL = 'TOGGLE_MEETING_MODAL'
export const CREATE_MEETING_LOADING_START = 'CREATE_MEETING_LOADING_START'
export const CREATE_MEETING_LOADING_END = 'CREATE_MEETING_LOADING_END'
